import type { RestRecord } from '@libs/data-access/entities'
import { Text } from '@libs/ui/ds'
import { usePlanningFormTranslation } from '@libs/utils/translations'
import type { FC } from 'react'

type Props = {
  customRestModifier: RestRecord['rest_value_updated_by']
  customRestModifiedAt: string | Date
}

export const RestRevaluatedBy: FC<Props> = ({
  customRestModifier,
  customRestModifiedAt
}) => {
  const { t } = usePlanningFormTranslation()

  return (
    <Text className='italic text-neutral-500'>
      {t('restForm.restEditAt', {
        date: customRestModifiedAt,
        firstname: customRestModifier?.get('firstname'),
        lastname: customRestModifier?.get('lastname')
      })}
    </Text>
  )
}
